const translations = {
  PageTitle: "Merge Object Types",
  Intro:
    "Reassign every classification of one object type onto another, across every region, then delete the source type. This is irreversible.",
  SourceTypeLabel: "Object type to merge away",
  TargetTypeLabel: "Object type to keep",
  IdLabel: (id: number) => `ID: ${id}`,
  InternalLabel: "Internal",
  SensitiveLabel: "Sensitive",
  SameTypeError: "Source and target must be different object types",
  PreviewButton: "Preview",
  PreviewLoading: "Loading preview…",
  PreviewError: "Failed to load preview",
  MergeButton: "Merge…",
  MergeButtonLocked: (seconds: number) => `Merge… (${seconds})`,
  RegionColumn: "Region",
  ReassignColumn: "Reassign",
  ConflictsColumn: "Conflicts removed",
  DatasetColumn: "Datasets flagged",
  DefectDatasetColumn: "Defect datasets flagged",
  TypeConversionColumn: "Type conversions removed",
  ClientMapColumn: "Client type maps removed",
  DpPowerMapColumn: "DP Power maps removed",
  CascadeColumn: "Other cascaded rows",
  ConfirmDialogTitle: "Merge object type?",
  ConfirmDialogBody: (sourceName: string, targetName: string) =>
    `This reassigns every classification of "${sourceName}" onto "${targetName}" in every region, then deletes "${sourceName}". This cannot be undone.`,
  ConfirmTypeToConfirmLabel: (sourceName: string) =>
    `Type "${sourceName}" to confirm`,
  ConfirmCancel: "Cancel",
  ConfirmMerge: "Merge",
  MergeSuccess: "Merge completed",
  MergePartialFailure: "Merge completed in some regions but failed in others",
  MergeFailed: "Merge failed in every region",
  MergeError: "Failed to run the merge",
  ResultsTitle: "Merge results",
  StatusMerged: "Merged",
  StatusAlreadyMerged: "Already merged",
  StatusError: "Error",
};

export default translations;
